import { Navigate } from 'react-router-dom';

import { ROUTES } from '@/config/routes';
import useFundedAccount from '@/hooks/use-funded-account';

interface FundedAccountGuardProps {
  children: React.ReactNode;
}

export const FundedAccountGuard = ({ children }: FundedAccountGuardProps) => {
  const { isFundedOrEval } = useFundedAccount();

  if (isFundedOrEval) {
    return <Navigate to={ROUTES.PORTFOLIO} replace />;
  }

  return <>{children}</>;
};
